import { render, staticRenderFns } from "./mallPicture3.vue?vue&type=template&id=16d120a4&scoped=true"
import script from "./mallPicture3.vue?vue&type=script&lang=js"
export * from "./mallPicture3.vue?vue&type=script&lang=js"
import style0 from "./mallPicture3.vue?vue&type=style&index=0&id=16d120a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d120a4",
  null
  
)

export default component.exports